export default __webpack_public_path__ + "static/media/tereal.7a83a685.jpg";